import React from 'react';
import Box from '@mui/material/Box';
import ShoppingCartPopup from './ShoppingCartPopup';

const ShoppingCartBadge = React.lazy(() => import("./ShoppingCartBadge")); 

const ShoppingCart = () => {
  const [anchorEl, setAnchorEl] = React.useState <EventTarget & HTMLSpanElement | null>(null);

  const openShoppingPop: React.MouseEventHandler<HTMLSpanElement> = (e) => {
    setAnchorEl(e.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      <Box
        sx={{
          display: { xs: "none", lg: "block" },
          position: "fixed",
          right: "0",
          paddingTop: "50px",
          paddingRight: "50px",
          textAlign: "right",
        }}
        onClick={openShoppingPop}
        className='important'
      >
        <ShoppingCartBadge
          onClick={openShoppingPop}
        />
      </Box>
      <ShoppingCartPopup 
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
      />
    </React.Fragment>
  )
}

export default ShoppingCart;